/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to override" |
*
* @param {Override_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_error = /** @type {((inputs?: Override_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la modification")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al anular")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao substituir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrittura fallita")
	return /** @type {LocalizedString} */ ("Failed to override")
});